import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import { initializeApp } from 'framework-react-core';
import { VITE_API_URL } from './utilities/env';
import { Provider } from 'react-redux';
import { store } from './redux/store';
import App from './App';

(async () => {
  await initializeApp(`${VITE_API_URL}/config/ui`);

  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <Provider store={store}>
        <App />
      </Provider>
    </StrictMode>
  );
})();
